import * as React  from 'react';
import { ActorAvatar, ActorName } from './actor';
import { combinedViewTime } from './dateKey';
import ActivityTitle from './activityTitle';

/**
 * An Activity was created under this Workkard.
 *
 * The component previously fetched the activity's attachments on mount and
 * tracked a local flag to decide when to draw them. Attachments are now their
 * own entry type, so this renders the creation event alone.
 */
export default function ActivityTemplate({ data, isPrintPreview }) {
    return (
            <div className="combinedListing detailListing">
                <div className="combinedCreatedDate detailCreatedDate">
                    <ActorAvatar userId={data.actor_id} />
                </div>
                <div className="combinedRightBlock detailRightBlock resolutionChanged">
                    <div className="combinedDescription detailDescription">
                        <div className="alignMiddle mb mb__8 flexWrap">
                            <ActorName userId={data.actor_id} inner="header" />
                            <span className="dateTime mr">
                            <label className="mrNone">{combinedViewTime(data.occurred_at)}</label>
                            </span>
                            added activity
                            <ActivityTitle activity={data.activity} isPrintPreview={isPrintPreview} />
                        </div>
                    </div>
                </div>
        </div>
    )
}
